import React, { Component } from 'react'
import Mainsec from '../coursetemplate/mainsec'
import Syllabus from '../coursetemplate/syllabus'
import Coursereview from '../coursetemplate/Course-review'
import Overview from '../coursetemplate/overview'
import Coursefeature from '../coursetemplate/coursefeature'
import Batchtime from '../coursetemplate/batchtime'
import Relatedcourse from '../coursetemplate/other-course'
import LearnSoftLogo from '../coursetemplate/CourseLogo'
import CourseEligibility from '../coursetemplate/Course-Eligibility'
import EnrollnowBox from '../coursetemplate/enroll-box'
import Faqs from '../coursetemplate/faq'
import NewMainsec from '../coursetemplate/new-mainsec'
export default class Jiratemplate extends Component {
 
  render() {
    const course =[
      {
        title: "Introduction to Jira",
        content: [
        "Overview of Jira and its uses",
        "Basic concepts and terminology",
        "Understanding Agile methodologies and how Jira supports them",
        "Jira installation and configuration"
        ]
        },
        {
        title: "Working with Issues in Jira",
        content: [
        "Creating and managing issues",
        "Issue workflows and statuses",
        "Customizing issue types and fields",
        "Bulk issue operations"
        ]
        },
        {
        title: "Agile Project Planning in Jira",
        content: [
        "Creating and managing projects",
        "Sprint planning and management",
        "Creating and managing backlogs",
        "Agile boards (Scrum and Kanban)"
        ]
        },
        {
        title: "Collaboration and Reporting in Jira",
        content: [
        "Collaborating with teams and stakeholders",
        "Creating and sharing reports and dashboards",
        "Jira Service Desk for customer support",
        "Advanced Agile reporting with Jira"
        ]
        },
        {
        title: "Advanced Jira Administration",
        content: [
        "Managing users and groups",
        "Creating and configuring Jira workflows",
        "Customizing Jira fields and screens",
        "Jira automation with scripting and plugins"
        ]
        },
        {
        title: "Configuring Jira for DevOps Workflows",
        content: [
        "Using Jira for continuous integration and deployment (CI/CD)",
        "Jira and Git integration",
        "Best practices for integrating Jira with DevOps tools"
        ]
        },
        {
        title: "Jira and Portfolio Management",
        content: [
        "Managing multiple projects in Jira",
        "Jira portfolio management features",
        "Best practices for using Jira for portfolio management"
        ]
        },
        {
        title: "Scaling Jira for Large Teams and Complex Projects",
        content: [
        "Jira performance optimization",
        "Scaling Jira for large teams and enterprise projects",
        "Integrating Jira with other tools and systems",
        "Best practices for Jira administration and governance"
        ]
        },
        {
        title: "Advanced Jira Reporting",
        content: [
        "Advanced Jira reporting with plugins and APIs",
        "Creating custom Jira reports",
        "Integrating Jira with business intelligence (BI) tools"
        ]
        },
        {
        title: "Jira Data Analysis and Management",
        content: [
        "Jira data analysis with JQL",
        "Data management and archiving in Jira",
        "Jira data migration and consolidation",
        "Jira add-ons for data management and analysis"
        ]
        },
        {
        title: "Jira Automation and Customization",
        content: [
        "Jira automation with scripting and add-ons",
        "Customizing Jira with plugins and add-ons",
        "Jira API integration with external tools"
        ]
        },
    ]

    const faqData = [
      {
        question: 'What is Jira Admin?',
        answer:
          'Jira Admin refers to the role responsible for configuring, customizing, and managing Jira, a popular project management and issue tracking tool developed by Atlassian',
      },
      {
        question: 'Why is Jira Admin important?',
        answer:
          'Jira Admin plays a crucial role in ensuring that Jira is effectively configured to meet the needs of the organization, enabling efficient project management, collaboration, and workflow automation',
      },
      {
        question: 'Who can benefit from Jira Admin training at the best training centre?',
        answer:
          'Jira Admin training at the best training centre is suitable for IT professionals, project managers, software developers, and anyone involved in project management and issue tracking using Jira'
        
        },
      {
        question: `What career opportunities are available for someone with ${this.props.title} skills?`,
        answer:
          'A person with Jira skills can pursue a variety of career opportunities such as Project Manager, Scrum Master, Agile Coach, and Software Developer.'
      },
      {
        question: 'Is there a certificate of completion offered for the courses on Learnsoft.org?',
        answer:
          'Yes, upon completion of a course on Learnsoft.org, students will receive a certificate of completion that can be added to their professional portfolio or resume.',
      },
    ];
    const EligibilityData=[
      {
        cnt:"Embark on a transformative journey into Jira Administration with the Best Training Centre. Our comprehensive Jira Admin training program welcomes learners from diverse backgrounds, regardless of prior experience. Whether you're an IT professional looking to enhance your skills or a newcomer eager to explore the world of Jira Administration, our courses cater to individuals at every skill level. With a focus on practical application and hands-on learning, our expert instructors guide you through essential Jira Admin concepts, tools, and methodologies. At the Best Training Centre, we prioritize accessibility and inclusivity, ensuring that all learners have the opportunity to thrive in the dynamic field of Jira Administration. Join us and unlock your potential with the best training centre for Jira Admin"
      },
    ]

    const ReviewData=[
      {
          img:"/course-img/course-review/learnsoft-logo.webp",
          Username:"Rihaan",
          date:" july 09 ,2023",
          review:` learnsoft.org has earned a reputation as a leading platform for ${this.props.title} training in ${this.props.location}. Their programs are designed to provide a comprehensive understanding of ${this.props.title} modules, making them a top choice for HR professionals.`
      },
      { img:"/course-img/course-review/learnsoft-logo.webp",
          Username:"Ananya",
          date:" july 29 ,2023",
          review:`${this.props.title}, staying informed about the latest trends, tools, and best practices is essential. learnsoft.org recognizes this need and provides a dedicated section for ${this.props.title} reviews.`
      },
  ]
     return(
      <>
    
          {/* <Mainsec img={this.props.url} title={this.props.title} location={this.props.location} location1={this.props.location1} intro="At learnsoft.org will provide students with a comprehensive understanding of Jira, a popular tool used for Agile project management. Students will learn how to use Jira to plan, track, and manage projects using Agile methodologies such as Scrum and Kanban. The course will cover topics such as issue tracking, project planning, team collaboration, advanced Jira administration, and advanced Agile reporting.."/> */}
          
          <NewMainsec rating='4.7' students={"652"} durations={"45"} img={this.props.url} title={this.props.title} location={this.props.location} location1={this.props.location1} intro="At learnsoft.org will provide students with a comprehensive understanding of Jira, a popular tool used for Agile project management. Students will learn how to use Jira to plan, track, and manage projects using Agile methodologies such as Scrum and Kanban. The course will cover topics such as issue tracking, project planning, team collaboration, advanced Jira administration, and advanced Agile reporting.."/>

            <Coursefeature title={this.props.title} location1={this.props.location1}/>
 <section className="pdt50">
		<Overview heading={`${this.props.title} ${this.props.location1} - Course Overview`} content={`Jira ${this.props.location1} is in high demand as organizations increasingly adopt Jira for project management. At Learnsoft.org, we offer top-notch Jira training courses in ${this.props.location} to help individuals enhance their skills and gain a comprehensive understanding of Jira principles and practices. Our experienced trainers use a hands-on approach, incorporating real-world scenarios and practical exercises to provide a well-rounded education. Whether you're new to Jira or looking to expand your skillset, Learnsoft.org's Jira ${this.props.location1} is the perfect choice to take your career to the next level. Contact us today to learn more about our courses and start your Jira journey.`} 
    title={this.props.title} location={this.props.location} location1={this.props.location1} course={"Our Jira course covers a wide range of topics, including project management, agile methodologies, and issue tracking. Our experienced trainers will guide you through hands-on exercises and real-world scenarios to help you understand the concepts and techniques used in Jira. By the end of the course, you will be able to implement Jira practices in your own projects."}/>
           </section>
 <Batchtime title={this.props.title} fees="25,999" offer="18,999"/>
 <CourseEligibility heading3={`Eligibility requirements for learnsoft's ${this.props.title} Training`} EligibilityData={EligibilityData}/>
 <EnrollnowBox bgimg={"/course-img/Enroll-box-imgs/enroll-bg.webp"} heading4={`Boost Your Career Advancement: Empowering You to Reach New Heights as a ${this.props.title} Developer`}/>
 <Syllabus CurriculumData={course} title={this.props.title}/>
          <div className='df fjse mfdcr mfac'>
 <Coursereview ReviewData={ReviewData}/>
 <div className='df fjc'>
 <LearnSoftLogo/>
 </div>
 </div>
 <Faqs faqData={faqData} heading4={`Answering Your Questions about Learnsoft's ${this.props.title} Course`}/>
 <Relatedcourse location={this.props.relatedlocation} location1={this.props.location1} url1={this.props.url1}  cou="Trello" coupath="trello" cou1='Okta' coupath1='okta' cou2='Asana' coupath2='asana' cou7='SAP' coupath7='sap' cou4='Kanban' coupath4='kanban' cou5='Pega' coupath5='pega' cou6='Azure Administration' coupath6='azure-admin' 
         cou3='Scrum Master' coupath3='scrum-master' cou8='Dynamic365' coupath8='dynamic365' cou9='Bigfix' coupath9='bigfix'  cou10='Python' coupath10='python'/>
      </>
    );
  }
}
